export default __webpack_public_path__ + "static/6-1f601fdcae4bf122c3b73ae09f5d6962.png";